/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => ({
  input: {
    fontSize: 14,
    '&::placeholder': {
      fontStyle: 'italic',
      fontSize: 14,
    },
  },

  disabledInput: {
    WebkitTextFillColor: '#58606E !important',
    color: '#58606E  !important',
  },

  textarea: {
    fontSize: 14,
    '&::placeholder': {
      fontStyle: 'italic',
      fontSize: 14,
    },
  },

  select: {
    fontSize: 14,
    '&:before': {
      fontSize: 14,
    },
    '&:after': {
      fontSize: 14,
    },
  },

  root: {
    '&:hover $notchedOutline': {
      borderColor: '#3272D9',
    },
    '&.MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(0, 0, 0, 0.23)',
    },
    '&:hover $notchedOutlineError': {
      borderColor: 'red',
    },
    '&:focus-within $notchedOutline': {
      borderColor: '#3272D9',
    },
    '&:focus-within $notchedOutlineError': {
      borderColor: 'red',
    },
  },

  selectRoot: {
    '&:focus-within $notchedOutlineError': {
      borderColor: 'red',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#3272D9',
    },
    '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#3272D9',
    },
  },

  notchedOutline: {},
  notchedOutlineError: {
    borderColor: 'red',
    '&:hover $notchedOutline': {
      borderColor: 'red',
    },
  },
  adornEnd: {
    pointerEvents: 'unset'
  }
}))
